module.exports = __webpack_public_path__ + "img/tree-dark.e697f193.svg";